import React from 'react'
import styled from 'styled-components'

const IconInstagramStyle = styled.div`
    cursor: pointer;

    :hover {
        svg g {
            fill: var(--accent-color);
        }
    }
`

const IconInstagram = ({ socialLink }) => (
    <a href={socialLink} target="blank">
        <IconInstagramStyle>
            <svg
                width="38px"
                height="38px"
                viewBox="0 0 38 38"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>icon-instagram</title>
                <desc>Created with Sketch.</desc>
                <g
                    id="icon-instagram"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                >
                    <path
                        d="M19.0033463,12.3067485 C14.7467931,12.3067485 11.3134412,15.7401004 11.3134412,19.9966537 C11.3134412,24.2532069 14.7467931,27.6865588 19.0033463,27.6865588 C23.2598996,27.6865588 26.6932515,24.2532069 26.6932515,19.9966537 C26.6932515,15.7401004 23.2598996,12.3067485 19.0033463,12.3067485 Z M19.0033463,24.9960959 C16.2526492,24.9960959 14.0039041,22.7540435 14.0039041,19.9966537 C14.0039041,17.2392638 16.2459565,14.9972114 19.0033463,14.9972114 C21.7607362,14.9972114 24.0027886,17.2392638 24.0027886,19.9966537 C24.0027886,22.7540435 21.7540435,24.9960959 19.0033463,24.9960959 L19.0033463,24.9960959 Z M28.8014501,11.9921919 C28.8014501,12.9894032 27.9983268,13.7858338 27.0078081,13.7858338 C26.0105968,13.7858338 25.2141662,12.9827105 25.2141662,11.9921919 C25.2141662,11.0016732 26.0172895,10.1985499 27.0078081,10.1985499 C27.9983268,10.1985499 28.8014501,11.0016732 28.8014501,11.9921919 Z M33.8945901,13.8126046 C33.7808143,11.4099275 33.2320134,9.28165086 31.4718349,7.52816509 C29.7183491,5.77467931 27.5900725,5.22587842 25.1873954,5.10540993 C22.7110987,4.96486336 15.2889013,4.96486336 12.8126046,5.10540993 C10.4166202,5.21918572 8.28834356,5.76798661 6.52816509,7.52147239 C4.76798661,9.27495817 4.22587842,11.4032348 4.10540993,13.8059119 C3.96486336,16.2822086 3.96486336,23.704406 4.10540993,26.1807027 C4.21918572,28.5833798 4.76798661,30.7116564 6.52816509,32.4651422 C8.28834356,34.218628 10.4099275,34.7674289 12.8126046,34.8878974 C15.2889013,35.0284439 22.7110987,35.0284439 25.1873954,34.8878974 C27.5900725,34.7741216 29.7183491,34.2253207 31.4718349,32.4651422 C33.2253207,30.7116564 33.7741216,28.5833798 33.8945901,26.1807027 C34.0351366,23.704406 34.0351366,16.2889013 33.8945901,13.8126046 Z M30.6954824,28.8377022 C30.1734523,30.1494702 29.1628555,31.1600669 27.8443949,31.6887897 C25.8700502,32.4718349 21.1851645,32.2911322 19.0033463,32.2911322 C16.8215282,32.2911322 12.1299498,32.4651422 10.1622978,31.6887897 C8.85052984,31.1667596 7.83993307,30.1561629 7.31121026,28.8377022 C6.52816509,26.8633575 6.70886782,22.1784718 6.70886782,19.9966537 C6.70886782,17.8148355 6.53485778,13.1232571 7.31121026,11.1556051 C7.83324038,9.84383714 8.84383714,8.83324038 10.1622978,8.30451757 C12.1366425,7.52147239 16.8215282,7.70217513 19.0033463,7.70217513 C21.1851645,7.70217513 25.8767429,7.52816509 27.8443949,8.30451757 C29.1561629,8.82654769 30.1667596,9.83714445 30.6954824,11.1556051 C31.4785276,13.1299498 31.2978249,17.8148355 31.2978249,19.9966537 C31.2978249,22.1784718 31.4785276,26.8700502 30.6954824,28.8377022 Z"
                        id="Shape"
                        stroke="#EE0202"
                        fillRule="nonzero"
                    ></path>
                </g>
            </svg>
        </IconInstagramStyle>
    </a>
)

export default IconInstagram
